import React from 'react';
import { Switch } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Login from './containers/Login';
import LineLoginCallback from './containers/LineLoginCallback';
import PublicRoute from '../PublicRoute';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.common.white,
    display: 'flex',
    minHeight: 'calc(100vh - 100px)',
    padding: 0,
    width: '100%',
    marginTop: theme.spacing(2),
    '@media (min-width: 796px)': {
      maxWidth: '768px',
    },
    '@media (min-width: 976px)': {
      maxWidth: '876px',
      marginTop: theme.spacing(9),
    },
    '@media (min-width: 1180px)': {
      maxWidth: '1080px',
    },
    '@media (min-width: 1440px)': {
      maxWidth: '1340px',
    },
  },
}));

export default () => {
  const classes = useStyles();

  return (
    <Container className={classes.root} maxWidth={false}>
      <Switch>
        <PublicRoute path="/login/line/callback" component={LineLoginCallback} />
        <PublicRoute path="/login" component={Login} />
      </Switch>
    </Container>
  );
};
